// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8238) return "static/chunks/8238.66fbe1d206584fed.js";
	if (chunkId === 3888) return "static/chunks/3888.43332f83a581b0ce.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"226":"595bafb572cdf99c","2551":"ca04f13a16f28e93","2765":"cf1b0d117c487c78","3170":"e8cd0b96b4b581fb","5134":"89c559277c660f48","5866":"55876f010365567f"}[chunkId] + ".js";
};